import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

@Component({
  selector: 'bz-count-packaging',
  templateUrl: './bz-count-packaging.component.html',
  styleUrls: ['./bz-count-packaging.component.sass']
})
export class BzCountPackagingComponent {
  public disableInput: boolean = true;

  @Input() qty: number;
  @Input() type: 'parent' | 'child';
  @Input() max: number = 100;
  @Input() namePack: string;
  @Input() isCart: boolean = false;

  @Output() onDecrementCount: EventEmitter<number> = new EventEmitter();
  @Output() onCountChange: EventEmitter<number> = new EventEmitter();
  @Output() onIncrementCount: EventEmitter<number> = new EventEmitter();

  constructor(
    private cdr: ChangeDetectorRef
  ) { }


  public plus(): void {
    this.onIncrementCount.emit(this.qty);
  }

  public minus(): void {
    this.onDecrementCount.emit(this.qty);
  }

  public edit(value: string): void {
    if (Number(value) >= 0 && this.qty !== Number(value)) {
      this.onCountChange.emit(Number(value));
    };
    this.cdr.detectChanges();
  }

}
